import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  CompanyQineticPaymentSource,
  CompanyQineticPaymentSourceService,
} from 'src/app/core/company-qinetic-payment-source.service';
import {
  CompanyStripePaymentSource,
  CompanyStripePaymentSourceService,
} from 'src/app/core/company-stripe-payment-source.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ERROR_QINETIC_PS_NOT_FOUND_CODE, ERROR_STRIPE_PS_NOT_FOUND_CODE } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-companies-payment-methods-dialog',
  templateUrl: './companies-payment-methods-dialog.component.html',
  styleUrls: ['./companies-payment-methods-dialog.component.scss'],
})
export class CompaniesPaymentMethodsDialogComponent {
  company_id?: string;
  qinetic_payment_sources?: CompanyQineticPaymentSource[];
  stripe_payment_sources?: CompanyStripePaymentSource[];
  is_qinetic_ps_list_running: boolean = false;
  is_stripe_ps_list_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesPaymentMethodsDialogComponent>,
    private company_qinetic_payment_source_service: CompanyQineticPaymentSourceService,
    private company_stripe_payment_source_service: CompanyStripePaymentSourceService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company_id = data.company_id;
  }

  ngOnInit(): void {
    if (this.company_id) {
      this.listQineticPaymentSources(this.company_id);
      this.listStripePaymentSources(this.company_id);
    }
  }

  onRefresh(): void {
    if (this.company_id) {
      this.listQineticPaymentSources(this.company_id);
      this.listStripePaymentSources(this.company_id);
    }
  }

  onClearQineticClick(ps?: CompanyQineticPaymentSource[]): void {
    if (this.company_id && ps?.length && ps[0]?.company_qinetic_payment_source_id) {
      this.deleteQineticPaymentSource(this.company_id, ps[0].company_qinetic_payment_source_id);
    }
  }

  onClearStripeClick(ps?: CompanyStripePaymentSource[]): void {
    if (this.company_id && ps?.length && ps[0]?.company_stripe_payment_source_id) {
      this.deleteStripePaymentSource(this.company_id, ps[0].company_stripe_payment_source_id);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  listQineticPaymentSources(company_id: string): void {
    this.is_qinetic_ps_list_running = true;
    this.company_qinetic_payment_source_service.listCompanyQineticPaymentSources(company_id).subscribe({
      next: repsonse => {
        this.qinetic_payment_sources = repsonse.data;
        this.is_qinetic_ps_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code != ERROR_QINETIC_PS_NOT_FOUND_CODE) this.dialog_ref.close({ error: processed_error });
        this.qinetic_payment_sources = [];
        this.is_qinetic_ps_list_running = false;
      },
    });
  }

  listStripePaymentSources(company_id: string): void {
    this.is_stripe_ps_list_running = true;
    this.company_stripe_payment_source_service.listCompanyStripePaymentSources(company_id).subscribe({
      next: repsonse => {
        this.stripe_payment_sources = repsonse.data;
        this.is_stripe_ps_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code != ERROR_STRIPE_PS_NOT_FOUND_CODE) this.dialog_ref.close({ error: processed_error });
        this.stripe_payment_sources = [];
        this.is_stripe_ps_list_running = false;
      },
    });
  }

  deleteQineticPaymentSource(company_id: string, cqps_id: string): void {
    this.is_qinetic_ps_list_running = true;
    this.company_qinetic_payment_source_service.deleteCompanyQineticPaymentSource(company_id, cqps_id).subscribe({
      next: () => {
        this.onRefresh();
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_qinetic_ps_list_running = false;
      },
    });
  }

  deleteStripePaymentSource(company_id: string, csps_id: string): void {
    this.is_stripe_ps_list_running = true;
    this.company_stripe_payment_source_service.deleteCompanyStripePaymentSource(company_id, csps_id).subscribe({
      next: () => {
        this.onRefresh();
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_stripe_ps_list_running = false;
      },
    });
  }
}
